import { render, staticRenderFns } from "./ChartBarHorizontal.vue?vue&type=template&id=7aec56a5&scoped=true&"
import script from "./ChartBarHorizontal.vue?vue&type=script&lang=js&"
export * from "./ChartBarHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aec56a5",
  null
  
)

export default component.exports